module.exports = __webpack_public_path__ + "static/media/Drawdown5PuttingItAllTogether.63e47515.jpg";